(function($, Drupal) {
  'use strict';
  // Collection of view specific behaviors
  Drupal.behaviors.view_custom_behaviors = {
    attach: function(context, settings) {
      //Submits form on change
      $('#views-exposed-form-networking-groups-networking-groups select').change(function() {
        console.log('first form');
        $('#views-exposed-form-networking-groups-networking-groups').submit();
      });
      $('#views-exposed-form-events-block-events-list-market-segment select').change(function() {
        console.log('second form');
        $('#views-exposed-form-events-block-events-list-market-segment').submit();
      });
    }
  };
})(jQuery, Drupal);
